export default __webpack_public_path__ + "static/media/new-campaign-1x.a30de3db.png";